export enum ServiceCaseItemType {
  PART = 'PART',
  FLAT_RATE_UNIT = 'FLAT_RATE_UNIT',
  DEFECT = 'DEFECT',
  PACKAGE = 'PACKAGE',
  JOB = 'JOB'
}
